module.exports = __webpack_public_path__ + "img/Aershan1.30b99ec2.png";